let _ = t => t,
  _t;
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import styledWithTheme from 'foundations-theming/utils';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { PinIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTableRow = styledWithTheme.tr(_t || (_t = _`
  cursor: ${0};
`), ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer');
const AccountRow = ({
  account,
  isSelected,
  onSelect,
  disabled,
  appName
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(StyledTableRow, {
      disabled: disabled,
      children: [/*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "developer-experience-shared-components.accountPicker.table.disabledTooltip",
            options: {
              appName
            }
          }),
          disabled: !disabled,
          placement: "left",
          children: /*#__PURE__*/_jsx(RadioInput, {
            disabled: disabled,
            name: "row",
            onChange: () => onSelect(account),
            checked: isSelected,
            alignment: "center",
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "300",
              children: [account.pinned && /*#__PURE__*/_jsx(IconCircle, {
                color: "icon-core-on-fill-default",
                backgroundColor: "fill-accent-light-orange-default",
                icon: PinIcon,
                size: "100"
              }), account.accountName || account.domain]
            })
          })
        })
      }), /*#__PURE__*/_jsxs("td", {
        children: [account.domain, /*#__PURE__*/_jsx(Text, {
          color: "icon-core-subtle",
          marginBlockStart: "100",
          children: account.portalId
        })]
      })]
    })
  );
};
export default AccountRow;